import { DateTimePreferencesProvider } from '@/features/date-time-preferences/providers/DateTimePreferencesProvider';
import { Outlet } from 'react-router';

export const PublicApp = () => {
  return (
    <DateTimePreferencesProvider>
      <Outlet />
    </DateTimePreferencesProvider>
  );
};
